import "./index.css";

import appIcon from "./app_icon.png";
import screenGroups from "./screens/panel-groups.png";
import screenNetwork from "./screens/panel-network.png";
import screenDisks from "./screens/panel-disks.png";

const STATS = [
  { num: "0", label: "жёстких дисков в игровых ПК" },
  { num: "1", label: "образ Windows на весь клуб" },
  { num: "1", label: "человек управляет всем парком" },
  { num: "24/7", label: "локальная команда на связи" },
];

const BENEFITS = [
  {
    icon: "⏱️",
    title: "Экономия времени",
    text: "Установили игру или обновление один раз — оно появилось на всех ПК клуба. Никаких обходов зала с флешкой и ночных переустановок.",
  },
  {
    icon: "💸",
    title: "Экономия на железе",
    text: "Игровым ПК не нужны собственные диски: вся дисковая система живёт на сервере. Меньше железа — меньше затрат и поломок.",
  },
  {
    icon: "🧹",
    title: "Чистая система всегда",
    text: "Вирусы, читы и мусор не переживают перезагрузку: каждый ПК стартует с чистого эталонного образа, как в день установки.",
  },
  {
    icon: "🎛️",
    title: "Всё в одной панели",
    text: "Включение и выключение машин, статусы, группы, клиенты, тарифы и балансы — в одном приложении, с которым справится один человек.",
  },
];

const COMPARE_ROWS: {
  feature: string;
  lobby: [string, "ok" | "no" | "mid"];
  hdd: [string, "ok" | "no" | "mid"];
  thin: [string, "ok" | "no" | "mid"];
}[] = [
  {
    feature: "Жёсткий диск в каждом ПК",
    lobby: ["Не нужен", "ok"],
    hdd: ["Нужен", "no"],
    thin: ["Не нужен", "ok"],
  },
  {
    feature: "Windows 10 / 11",
    lobby: ["Да", "ok"],
    hdd: ["Да", "ok"],
    thin: ["Ограниченно", "mid"],
  },
  {
    feature: "Обновление всех ПК за один раз",
    lobby: ["Да", "ok"],
    hdd: ["Нет", "no"],
    thin: ["Частично", "mid"],
  },
  {
    feature: "Чистая система после перезагрузки",
    lobby: ["Да", "ok"],
    hdd: ["Нет", "no"],
    thin: ["Не всегда", "mid"],
  },
  {
    feature: "AAA-игры на полную мощность",
    lobby: ["Да", "ok"],
    hdd: ["Да", "ok"],
    thin: ["Нет", "no"],
  },
  {
    feature: "Учёт времени и тарифы встроены",
    lobby: ["Да", "ok"],
    hdd: ["Нет", "no"],
    thin: ["Редко", "mid"],
  },
  {
    feature: "Затраты на железо",
    lobby: ["Заметно ниже", "ok"],
    hdd: ["Высокие", "no"],
    thin: ["Ниже", "ok"],
  },
  {
    feature: "Управление одним человеком",
    lobby: ["Да", "ok"],
    hdd: ["Долго и вручную", "no"],
    thin: ["Да", "ok"],
  },
];

const STEPS = [
  {
    title: "Включаете клуб из панели",
    text: "Все ПК включаются удалённо — хоть по одному, хоть весь зал разом, без беготни по рядам.",
  },
  {
    title: "ПК загружаются с сервера",
    text: "Каждая машина получает по сети общий образ Windows со всеми играми и настройками клуба.",
  },
  {
    title: "Игроки садятся и играют",
    text: "На экране — вход и таймер, сервер сам ведёт учёт времени и предупреждает об окончании сессии.",
  },
  {
    title: "Перезагрузка — и снова чисто",
    text: "Всё, что менялось за сессию, исчезает. ПК снова в эталонном состоянии и готов к следующему игроку.",
  },
];

const FEATURES = [
  {
    icon: "⚡",
    title: "Загрузка по сети",
    text: "Игровые ПК стартуют прямо с сервера — на них не нужно ничего устанавливать. Новую машину достаточно подключить к сети клуба: панель сама её увидит и предложит добавить.",
  },
  {
    icon: "💿",
    title: "Один образ на весь клуб",
    text: "Windows, игры, драйверы и настройки хранятся в одном эталонном образе. Все ПК работают с него одновременно, а нагрузка распределяется по накопителям сервера.",
  },
  {
    icon: "🔄",
    title: "Обновление в один клик",
    text: "Назначьте любой ПК «супер-клиентом», установите на нём обновления — и новый образ автоматически разъедется по всем машинам клуба.",
  },
  {
    icon: "🖥️",
    title: "Панель администратора",
    text: "Статус каждого ПК в реальном времени, удалённое включение и выключение, группы машин, клиенты и настройки — всё в одном настольном приложении с ролями администратора и оператора.",
  },
  {
    icon: "🕐",
    title: "Тарифы и пакеты времени",
    text: "Поминутные и пакетные тарифы с расписанием по часам, дням недели и зонам клуба. Пополнение балансов и продажа пакетов — в пару кликов.",
  },
  {
    icon: "📡",
    title: "Сессии под контролем",
    text: "Таймер и тариф — на экране игрока, а если оболочку закрыть, она тут же перезапустится. Сервер предупредит об окончании времени, продлит пакет или завершит сессию, а при обрыве связи не спишет лишнего.",
  },
];

// Screenshot copy stays free of protocol jargon (owner directive) — the UI
// on the images may show it, but the landing text must not.
const SCREENS = [
  {
    src: screenGroups,
    alt: "Экран «Компьютерные группы» в панели Lobby Boot: список групп зала и машины в них",
    title: "Группы компьютеров",
    text: "Весь парк как на ладони: зоны зала, статус каждой машины и добавление новых ПК в пару кликов.",
    featured: true,
  },
  {
    src: screenNetwork,
    alt: "Экран сетевых настроек клуба в панели Lobby Boot",
    title: "Сетевые настройки",
    text: "Сеть клуба настраивается один раз при внедрении — дальше сервер сам раздаёт машинам всё нужное.",
    featured: false,
  },
  {
    src: screenDisks,
    alt: "Экран дисковой системы в панели Lobby Boot: эталонный образ и активные сессии машин",
    title: "Дисковая система",
    text: "Эталонный образ, распределение нагрузки по накопителям и активные сессии машин — в реальном времени.",
    featured: false,
  },
];

const FAQ = [
  {
    q: "Что такое бездисковая загрузка?",
    a: "У игровых ПК нет собственных дисков и установленной Windows. При включении машина получает систему по локальной сети с сервера клуба и работает с общим образом. Для игрока всё выглядит как обычный компьютер.",
  },
  {
    q: "Пойдут ли современные AAA-игры?",
    a: "Да. Игра выполняется на самом ПК — работают его видеокарта, процессор и память. Сервер лишь отдаёт данные диска по быстрой локальной сети, поэтому машины сохраняют полную игровую производительность.",
  },
  {
    q: "Нужно ли переустанавливать Windows на машинах?",
    a: "Нет — на игровых ПК вообще нет своей Windows. Система живёт в одном образе на сервере, и любые изменения делаются один раз для всего клуба.",
  },
  {
    q: "Как обновлять игры и систему?",
    a: "Один из ПК назначается «супер-клиентом» и получает образ на запись. Обновили на нём игры или Windows — и после подтверждения новый образ автоматически прописывается всем машинам.",
  },
  {
    q: "Что если игрок что-то сломает или поймает вирус?",
    a: "Ничего страшного: все изменения пишутся отдельно от эталонного образа и живут только до перезагрузки. Перезапустили ПК — и он снова абсолютно чистый.",
  },
  {
    q: "Как попробовать Lobby Boot?",
    a: "Напишите нам — покажем платформу в работе, ответим на вопросы про ваше железо и поможем спланировать переход клуба на бездисковую загрузку.",
  },
];

export function App() {
  return (
    <>
      <header className="site-header">
        <div className="container">
          <a className="brand" href="#">
            <img src={appIcon} alt="Логотип Lobby Boot" />
            <span>
              Lobby<em>Boot</em>
            </span>
          </a>
          <nav className="site-nav">
            <a href="#compare">Сравнение</a>
            <a href="#how">Как это работает</a>
            <a href="#features">Возможности</a>
            <a href="#screens">Панель</a>
            <a href="#faq">FAQ</a>
            <a href="#contact">Контакты</a>
          </nav>
        </div>
      </header>

      <main>
        <section className="hero">
          <div className="container">
            <span className="hero-eyebrow">Бездисковая платформа для компьютерных клубов</span>
            <h1>
              Компьютерный клуб <em>без жёстких дисков</em>
            </h1>
            <p className="hero-lead">
              Lobby Boot загружает все игровые ПК по сети с одного сервера. После каждой
              перезагрузки машина снова как новая — без вирусов, мусора и слетевших
              настроек. Обновления ставятся один раз и сразу на весь клуб.
            </p>
            <div className="hero-actions">
              <a className="btn btn-primary" href="#contact">
                Связаться с нами
              </a>
              <a className="btn btn-ghost" href="#how">
                Как это работает
              </a>
            </div>
            <div className="stats">
              {STATS.map(s => (
                <div className="stat" key={s.label}>
                  <span className="stat-num">{s.num}</span>
                  <span className="stat-label">{s.label}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="section" id="benefits">
          <div className="container">
            <h2 className="section-title">Что это даёт клубу</h2>
            <p className="section-subtitle">
              Меньше железа, меньше ручной работы и всегда чистые машины — клуб обслуживает
              один человек из одной панели.
            </p>
            <div className="feature-grid benefits-grid">
              {BENEFITS.map(b => (
                <article className="feature-card" key={b.title}>
                  <div className="feature-icon" aria-hidden="true">
                    {b.icon}
                  </div>
                  <h3>{b.title}</h3>
                  <p>{b.text}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="section section-alt" id="compare">
          <div className="container">
            <h2 className="section-title">Почему бездисковая загрузка</h2>
            <p className="section-subtitle">
              Три способа организовать клуб — и что каждый из них означает на практике.
            </p>
            <div className="compare-wrap">
              <table className="compare">
                <thead>
                  <tr>
                    <th>Возможность</th>
                    <th className="col-lobby">Lobby Boot</th>
                    <th>Локальные диски</th>
                    <th>Тонкий клиент</th>
                  </tr>
                </thead>
                <tbody>
                  {COMPARE_ROWS.map(r => (
                    <tr key={r.feature}>
                      <td>{r.feature}</td>
                      <td className={`col-lobby cell-${r.lobby[1]}`}>{r.lobby[0]}</td>
                      <td className={`cell-${r.hdd[1]}`}>{r.hdd[0]}</td>
                      <td className={`cell-${r.thin[1]}`}>{r.thin[0]}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="support-banner">
              <span className="support-chip">
                <span className="support-dot" aria-hidden="true" />
                На связи 24/7
              </span>
              <h3>Мы работаем локально — и всегда рядом</h3>
              <p>
                Lobby Boot — это не переписка с поддержкой на другом конце света.
                Платформа работает на вашем собственном сервере внутри клуба, а наша
                команда всегда на связи: поможем с внедрением, настройкой и любым
                вопросом по работе клуба.
              </p>
              <p className="support-points">
                Свой сервер в клубе<span> · </span>Локальная команда
                <span> · </span>Живые люди на связи 24/7
              </p>
            </div>
          </div>
        </section>

        <section className="section" id="how">
          <div className="container">
            <h2 className="section-title">Как это работает</h2>
            <p className="section-subtitle">
              От включения зала до игровой сессии — четыре шага, и все они автоматические.
            </p>
            <div className="steps">
              {STEPS.map(s => (
                <div className="step" key={s.title}>
                  <h3>{s.title}</h3>
                  <p>{s.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="section section-alt" id="features">
          <div className="container">
            <h2 className="section-title">Возможности</h2>
            <p className="section-subtitle">
              Один сервер берёт на себя загрузку машин, учёт времени и контроль сессий.
            </p>
            <div className="feature-grid">
              {FEATURES.map(f => (
                <article className="feature-card" key={f.title}>
                  <div className="feature-icon" aria-hidden="true">
                    {f.icon}
                  </div>
                  <h3>{f.title}</h3>
                  <p>{f.text}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="section" id="screens">
          <div className="container">
            <h2 className="section-title">Панель управления вживую</h2>
            <p className="section-subtitle">
              Настоящие экраны панели Lobby Boot — без макетов и рендеров. Так клуб
              выглядит для администратора каждый день.
            </p>
            <div className="screens-grid">
              {SCREENS.map(s => (
                <figure
                  className={`screen-card${s.featured ? " screen-featured" : ""}`}
                  key={s.title}
                >
                  <img src={s.src} alt={s.alt} loading="lazy" />
                  <figcaption>
                    <h3>{s.title}</h3>
                    <p>{s.text}</p>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </section>

        <section className="section section-alt" id="soon">
          <div className="container">
            <h2 className="section-title">Скоро в Lobby Boot</h2>
            <p className="section-subtitle">
              Платформа активно развивается — вот что появится в ближайших обновлениях.
            </p>
            <div className="soon-grid">
              <article className="feature-card soon-card">
                <span className="soon-chip">Скоро</span>
                <h3>Новая оболочка игрока</h3>
                <p>
                  Обновлённый фирменный экран на каждом ПК: вход, таймер и тариф перед
                  глазами игрока — уже на финишной прямой.
                </p>
              </article>
              <article className="feature-card soon-card">
                <span className="soon-chip">Скоро</span>
                <h3>Мобильное приложение</h3>
                <p>
                  Статус зала и управление клубом прямо с телефона — где бы вы ни
                  находились. Сейчас в разработке.
                </p>
              </article>
            </div>
          </div>
        </section>

        <section className="section" id="faq">
          <div className="container">
            <h2 className="section-title">Частые вопросы</h2>
            <p className="section-subtitle">
              Коротко о том, что обычно спрашивают владельцы клубов.
            </p>
            <div className="faq-list">
              {FAQ.map(item => (
                <details className="faq-item" key={item.q}>
                  <summary>{item.q}</summary>
                  <p>{item.a}</p>
                </details>
              ))}
            </div>
          </div>
        </section>

        <section className="section section-alt cta" id="contact">
          <div className="container">
            <h2 className="section-title">Хотите перевести клуб на бездисковую загрузку?</h2>
            <p className="section-subtitle" style={{ marginBottom: 0 }}>
              Расскажите о вашем клубе — покажем платформу в работе и поможем спланировать
              внедрение.
            </p>
            <div className="cta-actions">
              <a
                className="btn btn-primary"
                href="https://wa.me/77073535549"
                target="_blank"
                rel="noopener noreferrer"
              >
                Написать в WhatsApp
              </a>
              <a
                className="btn btn-blue"
                href="https://t.me/Hellomik"
                target="_blank"
                rel="noopener noreferrer"
              >
                Написать в Telegram
              </a>
            </div>
            <p className="cta-contacts">
              <a className="phone" href="tel:+77073535549">
                +7 707 353 55 49
              </a>
              <span> · </span>
              <a href="mailto:hellomik2002@gmail.com">hellomik2002@gmail.com</a>
            </p>
            <p className="cta-note">Мы на связи 24/7 — всегда рядом с вашим клубом.</p>
          </div>
        </section>
      </main>

      <footer className="site-footer">
        <div className="container">
          <span>© {new Date().getFullYear()} Lobby Boot</span>
          <span>Платформа для компьютерных клубов</span>
        </div>
      </footer>
    </>
  );
}

export default App;
